export const chartColors = {
  "--ld-col-rp-700": "rgb(80, 50, 145)",
  "--ld-col-vy-200": "rgb(255, 200, 50)",
  "--ld-col-vg-500": "rgb(165, 205,080)",
  "--ld-col-vm-500": "rgb(235, 60, 150)",
  "--ld-col-vc-500": "rgb(045, 190, 205)",
};
